import { render } from "./CreateInvoice.vue?vue&type=template&id=27beb2f7&scoped=true"
import script from "./CreateInvoice.vue?vue&type=script&lang=js"
export * from "./CreateInvoice.vue?vue&type=script&lang=js"

import "./CreateInvoice.vue?vue&type=style&index=0&id=27beb2f7&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27beb2f7"]])

export default __exports__